<div soho-busyindicator
    [text]="' '"
    [displayDelay]="100"
    [overlayOnly]="true"
    [activated]="this.disabled"
    [style.height]="'100%'"
>

  <div [ngClass]="cubeHostContainerClass">
    <!-- The display type is chart only when in dashboard -->
    <ng-template [ngIf]="displayType === 'chart'">
      <div [ngClass]="'lm-cube-dashboard'">
        <lm-list-chart
            [listUrlInfo]="listUrlInfo"
            [listSpec]="listSpec"
            [listState]="listState"
            [chartName]="displayChartName"
        ></lm-list-chart>
      </div>
    </ng-template>

    <ng-template [ngIf]="displayType === 'tree'">
      <div class="no-scroll  lm-cube-view-tree-treechart">
        <div [ngClass]="{'scrollable-flex': true}" [style.height]="'100%'">
          <div class="scrollable-flex-header">
            <lm-toolbar
                *ngIf = "!isDashBoardContent"
                [toolbarIdPrefix]="toolbarId"
                [automationId]="screenAutomationId"
                [inHeader]="false"
                [buttons]="toolbarButtons | async"
                [disabled]="disabled"
                [sectionTitle]="listTitle"
                [hideToolbarTitles]="hideToolbarTitles"
                [hideOverflowMenuButton]="listSpec.showAsMingleWidget"
                [hideToolbarButtons]="false"
                [moreMenuSettings]="toolbarMoreMenuSettings"

                [class.showSearchForm]="false"
                [class.panel-header]="false"
                [class.card-group-action]="listSpec.showAsMingleWidget"

                (toolbarButtonEvent)="onToolbarButtonEvent($event)"
            ></lm-toolbar>
          </div>

          <div class="scrollable-flex-content" [style.overflow]="'auto'" [style.height]="'calc(100% - 42px)'">
            <lm-list-tree
                [listUrlInfo]="listUrlInfo"
                [listSpec]="listSpec"
                [listState]="listState"
                [listPersonalization]="listPersonalization"
                [cubeOrientation]="orientation"
                [disabled]="disabled"
                [fromDataView]="fromDataView"
                (cubeListSpecUpdated)="onCubeListSpecUpdated($event)"
            ></lm-list-tree>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template [ngIf]="displayType === 'treeandchart'">
      <div class="lm-cube-view-tree-treechart lm-cube-treeandchart">
        <div class="scrollable lm-cube-view-treelist">
          <div [ngClass]="{'scrollable-flex': true}" [style.height]="inMingleWidget ? 'calc(100% - 35px)' : '100%'">
            <div class="scrollable-flex-header">
              <lm-toolbar
                  [toolbarIdPrefix]="toolbarId"
                  [automationId]="screenAutomationId"
                  [inHeader]="false"
                  [buttons]="toolbarButtons | async"
                  [disabled]="false"
                  [hideToolbarTitles]="true"
                  [hideOverflowMenuButton]="listSpec.showAsMingleWidget"
                  [hideToolbarButtons]="false"
                  [moreMenuSettings]="toolbarMoreMenuSettings"

                  [class.showSearchForm]="false"
                  [class.panel-header]="false"
                  [class.card-group-action]="listSpec.showAsMingleWidget"

                  (toolbarButtonEvent)="onToolbarButtonEvent($event)"
              ></lm-toolbar>
            </div>

            <div class="scrollable-flex-content" [style.overflow]="'auto'"  [style.height]="'calc(100% - 42px)'">
              <lm-list-tree
                  [listUrlInfo]="listUrlInfo"
                  [listSpec]="listSpec"
                  [listState]="listState"
                  [listPersonalization]="listPersonalization"
                  [cubeOrientation]="orientation"
                  [disabled]="disabled"
                  [fromDataView]="fromDataView"
                  (cubeRowsSelected)="onCubeRowsSelected($event)"
                  (cubeListSpecUpdated)="onCubeListSpecUpdated($event)"
              ></lm-list-tree>
            </div>
          </div>
        </div>

        <div class="lm-splitter-container">
          <soho-splitter [collapseButton]="true" [style.height]="inMingleWidget ? 'calc(100% - 45px)' : '100%'">
          </soho-splitter>
          <div class="lm-splitter-container-chart">
              <lm-toolbar
                  [toolbarIdPrefix]="chartToolbarId"
                  [automationId]="screenAutomationId"
                  [inHeader]="false"
                  [sectionTitle]="chartTitle"
                  [buttons]="chartToolbarButtons | async"
                  [disabled]="false"
                  [hideOverflowMenuButton]="listSpec.showAsMingleWidget"
                  [hideToolbarTitles]="listSpec.showAsMingleWidget"
                  [moreMenuSettings]="toolbarMoreMenuSettings"

                  [class.showSearchForm]="false"
                  [class.panel-header]="false"
                  [class.card-group-action]="listSpec.showAsMingleWidget"

                  (toolbarButtonEvent)="onToolbarButtonEvent($event)"
              ></lm-toolbar>

            <lm-list-chart
                [listUrlInfo]="listUrlInfo"
                [listSpec]="listSpec"
                [listState]="listState"
                [chartName]="displayChartName"
                [periodIndex]="periodIndex"
            ></lm-list-chart>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  <!-- Placeholder for Cube dialogs -->
  <div #modalPlaceholder id="modalPlaceholder"></div>
</div>
